import React from 'react'
import PropTypes from 'prop-types'
import { MdArrowDropDown } from 'react-icons/md'
import styles from './selectField.module.scss'

const SelectField = (props) => {
  const {
    field: { name, id, value } = {},
    form: { setFieldValue } = {},
    options = [],
    placeholder
  } = props

  const optionsComponent = options.map((option) => (
    <option key={option.id} value={option.id}>
      {option.name}
    </option>
  ))

  const handleChange = (event) => {
    setFieldValue(name, [event?.target?.value])
  }

  return (
    <div className={styles.selectField}>
      <select id={id} name={name} value={value} onChange={handleChange}>
        <option value={undefined}>{placeholder}</option>

        {optionsComponent}
      </select>
      <MdArrowDropDown color="#737373" />
    </div>
  )
}

SelectField.defaultProps = {
  field: undefined,
  form: undefined,
  options: [],
  placeholder: ''
}

SelectField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      )
    ])
  }),
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    setFieldValue: PropTypes.func
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string
    })
  ),
  placeholder: PropTypes.string
}

export default SelectField
